(function (angular) {
    'use strict';

    angular.module('app')
        .filter('timeUntilNow', timeUntilNow);

    function timeUntilNow() {
        return function (input) {
            var now = window.moment(),
                member_years = window.moment().diff(input, 'years'),
                member_months_total = window.moment().diff(input, 'months'),
                member_months = member_months_total - (Math.floor(member_months_total / 12) * 12);

            if (member_months_total < 1) {
                return 'less than a month';
            }

            return member_years + ' year' + (member_years > 1 ? 's ' : ' ') + member_months + ' months';
        };
    }

}(angular));
